import get from "lodash/get";
import chain from "lodash/chain";
import React from "react";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import { useRillContext } from "../rill/RillReact/share/base";

const PAGES = {
  "Volume & Intensity": "/dashboard/metrics/volume-intensity",
  "Baseline Volume & Relative Intensity":
    "/dashboard/metrics/baseline-volume-relative-intensity",
  "Over/Under Baseline Volume": "/dashboard/metrics/over-under-baseline",
  "Volume Split by Core Lift": "/dashboard/metrics/volume-split-core-lift",
  "Personal Record Table": "/dashboard/metrics/record-table",
  "Number of Lifts": "/dashboard/metrics/number-of-lifts",
  "Primary & Secondary Volume Split":
    "/dashboard/metrics/core-accessory-volume-split",
  "1RM Estimation": "/dashboard/metrics/rep-max-estimator",
  "RPE Custom Tables": "/dashboard/metrics/rpe-table",
  "Custom Metric Reports": "/dashboard/metrics/custom",
};

const METRICS_PAGE_KEYS = {
  "Volume & Intensity": "volumeIntensity",
  "Baseline Volume & Relative Intensity":
    "baselineVolumeRelativeIntensity",
  "Over/Under Baseline Volume": "overUnderBaselineVolume",
  "Volume Split by Core Lift": "volumeSplitCoreLift",
  "Personal Record Table": "personalRecordTable",
  "Number of Lifts": "numberOfLifts",
  "Primary & Secondary Volume Split": "primarySecondaryVolumeSplit",
  "1RM Estimation": "repMaxEstimation",
  "RPE Custom Tables": "rpeCustomTables",
  "Custom Metric Reports": "customMetricReports",
};

function MetricsNav(props) {
  const { t } = useTranslation("dashboard");
  const {
    locals: {
      pathname,
      search,
      activeUserToRequest,
      query: { athlete },
    },
  } = useRillContext();

  let pages = chain(PAGES);

  const intensityMeasure =
    get(activeUserToRequest, "intensityMeasure", "rpe") === "rpe"
      ? "RPE"
      : "RiR";

  return (
    <div className="Heading-Nav" tabIndex="-1">
      <span>{t("metricsNav.metrics")}</span>
      <img src="/img/icons/chevron-down.svg" className="chevron-metrics" />
      <div className="dropdown nav">
        {pages
          .map((url, page) => {
            url = athlete ? url.replace("/dashboard", "/athlete-portal") : url;
            const label =
              page === "RPE Custom Tables"
                ? t("metrics.intensityMeasureCustomTables", {
                    intensityMeasure,
                  })
                : t("metricsNav.pages." + METRICS_PAGE_KEYS[page]);
            return (
              <li key={page}>
                <a
                  className={cx({ active: url === pathname })}
                  href={`${url}${search || ""}`}
                >
                  {label}
                </a>
              </li>
            );
          })
          .value()}
      </div>
    </div>
  );
}

export default MetricsNav;
